"use strict";
/*
 * Created on 31.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * @author MSu
 */


var EntityChangeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(EntityChangeConverter, _DataObjectConverter_);

  function EntityChangeConverter() {
    _classCallCheck(this, EntityChangeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntityChangeConverter).apply(this, arguments));
  }

  return EntityChangeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.EntityChangeConverter = EntityChangeConverter;